module.exports = __webpack_public_path__ + "media/packs/src/assets/images/lesson-management-4fe785bee5fc1ceb3213e23d1a8f9932.png";